import { BuildingIncidents } from "../../Molecules/BuildingDetails/BuildingDetail/BuildingIncidents/BuildingIncidents";
import { DigitalTwinPage } from "../../Molecules/BuildingDetails/BuildingDetail/Digital Twin/DigitalTwin";
import { ItemDetail } from "../../Molecules/RegistryDetail/ItemDetail";

export const RegistryGlobalSubTabs = [
  {
    name: "Overview",
    label: "overview",
    path: "overview",
    subTabsPath: ["details", "incidents", "digital-twin"],
    submenus: null,
    component: [ItemDetail, BuildingIncidents, DigitalTwinPage],
    buttons: ['Details', 'Incidents', 'Digital Twin']
  }
];